import { memo } from "react";
import { motion } from "framer-motion";

const R = 46;
const CIRC = 2 * Math.PI * R; // ≈ 289.03

function ProgressDialBase({ percent, completed, total }) {
  const offset = CIRC - (percent / 100) * CIRC;

  return (
    <div className="relative w-40 h-40 md:w-48 md:h-48">
      <svg viewBox="0 0 100 100" className="w-full h-full -rotate-90">
        <circle cx="50" cy="50" r={R} stroke="rgba(26,15,10,0.10)" strokeWidth="4" fill="none" />
        <motion.circle
          cx="50"
          cy="50"
          r={R}
          stroke="#6B0F1A"
          strokeWidth="4"
          fill="none"
          strokeLinecap="round"
          strokeDasharray={CIRC}
          initial={{ strokeDashoffset: CIRC }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-mono-tag text-[9px] text-[#78584B]">Complete</div>
        <div className="font-display text-5xl md:text-6xl font-extrabold text-[#6B0F1A] leading-none mt-1">
          {percent}
          <span className="text-[#78584B] text-2xl font-bold">%</span>
        </div>
        <div className="font-mono-tag text-[9px] text-[#78584B] mt-2">
          {completed} / {total} DOCS
        </div>
      </div>
    </div>
  );
}

export const ProgressDial = memo(ProgressDialBase);
